<template>
  <b-modal
    v-model="show"
    :title="title"
    hide-footer
    centered
  >
    <p class="mb-4">
      {{ message }}
    </p>

    <div class="d-flex justify-content-end gap-2">
      <b-button
        variant="secondary"
        class="mr-2"
        @click="cancel"
      >
        {{ cancelText }}
      </b-button>
      <b-button
        variant="danger"
        @click="confirm"
      >
        {{ confirmText }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    title: { type: String, default: 'Confirm Action' },
    message: { type: String, default: 'Are you sure?' },
    confirmText: { type: String, default: 'Yes' },
    cancelText: { type: String, default: 'Cancel' },
  },
  data() {
    return { show: false, resolver: null }
  },
  methods: {
    open() {
      this.show = true
      return new Promise((resolve) => {
        this.resolver = resolve
      })
    },
    confirm() {
      this.show = false
      if (this.resolver) this.resolver(true)
      this.resolver = null
    },
    cancel() {
      this.show = false
      if (this.resolver) this.resolver(false)
      this.resolver = null
    },
  },
}
</script>

<style scoped>
::v-deep(.close) {
  color: #fff;
}
</style>
